import { __module as simpleSwizzle } from "../../_virtual/index3.js";
import { i as isArrayish$1 } from "../is-arrayish/index.js";
var isArrayish = isArrayish$1, concat = Array.prototype.concat, slice = Array.prototype.slice, swizzle = simpleSwizzle.exports = function(args) {
  for (var results = [], i = 0, len = args.length; i < len; i++) {
    var arg = args[i];
    isArrayish(arg) ? results = concat.call(results, slice.call(arg)) : results.push(arg);
  }
  return results;
};
swizzle.wrap = function(fn) {
  return function() {
    return fn(swizzle(arguments));
  };
};
var simpleSwizzleExports = simpleSwizzle.exports;
export {
  simpleSwizzleExports as s
};
//# sourceMappingURL=index.js.map
